<div class="header-notification" *ngIf="announcement != null && announcement.isActive == true"
  [ngClass]="{ hide: !showCovidWarning }">
  <span>{{ announcement.description }}</span>
  <button type="button" role="button" (click)="showCovidWarning = false">
    <img src="/assets/images/close-home-white.svg" width="11" height="11" />
  </button>
</div>

<header>
  <div class="container">
    <nav class="navbar navbar-expand-xl navbar-light bg-transparent">
      <a class="navbar-brand" routerLink="/">
        <img src="/assets/images/the-branford-logo.svg" width="203" height="48" />
      </a>

      <div class="menu-notifications-icon-mobile">
        <!-- <div class="nav-item menu-notifications-icon" *ngIf="loggedIn && role == 'Buyer'">
          <div class="noti-dropdown" notification-counter></div>
        </div> -->

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" role="button"
          (click)="showNavBar = !showNavBar">
          <img src="../assets/images/mobile-toggle.svg" title="menu-toggle-icon" />
        </button>
      </div>

      <div class="collapse navbar-collapse" [ngClass]="{ show: showNavBar }">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <div class="btn-group" dropdown>
              <button dropdownToggle type="button" class="no-bg-btn nav-link" [class.active]="
                  router.isActive('/' + routes.currentAuction, true) ||
                  router.isActive('/' + routes.pastAuction, true) ||
                  router.isActive('/' + routes.turnKeySale, true) ||
                  router.isActive('/' + routes.machinery, true) ||
                  router.isActive('search-lot-catalog', true)
                ">
                Auctions
                <img src="/assets/images/arrow-down.svg" />
              </button>
              <ul *dropdownMenu class="dropdown-menu" role="menu">
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false"
                    [routerLink]="['/' + routes.currentAuction]" routerLinkActive="active">Current Auctions</a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false"
                    [routerLink]="['/' + routes.pastAuction]" routerLinkActive="active">Recent Auctions</a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false"
                    [routerLink]="['/' + routes.turnKeySale]" routerLinkActive="active">Past Turnkey Sales</a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false"
                    [routerLink]="['/' + routes.machinery]" routerLinkActive="active">Machinery Marketplace</a>
                <!-- </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false"
                    [routerLink]="['/' + routes.featuredPast]" routerLinkActive="active">Featured Past Auctions</a>
                </li> -->
                <li>
                  <a class="dropdown-item" target="_blank"
                    href="https://www.branfordauctions.com/dnn3/Auctions/UpcomingLots/tabid/1710/Default.aspx">Search Lot Catalogs</a>
                </li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" [routerLink]="['/valuations']" routerLinkActive="active">Valuations</a>
          </li>
          <li class="nav-item">
            <div class="btn-group" dropdown>
              <button dropdownToggle type="button" class="no-bg-btn nav-link" [class.active]="
                  router.isActive('/removal', true) ||
                  router.isActive('/payments', true) ||
                  router.isActive('/faq', true)
                ">
                Buyers
                <img src="/assets/images/arrow-down.svg" />
              </button>
              <ul *dropdownMenu class="dropdown-menu" role="menu">
                <li>
                  <a class="dropdown-item" [routerLink]="['/removal']" routerLinkActive="active">Removal/Rigging</a>
                </li>
                <li>
                  <a class="dropdown-item" [routerLink]="['/payments']" routerLinkActive="active">Payments</a>
                </li>
                <li>
                  <a class="dropdown-item" [routerLink]="['/faq']" routerLinkActive="active">FAQs</a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="button" (click)="showNavBar = false" [routerLink]="['/sellers']"
              routerLinkActive="active">Sellers</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="button" (click)="showNavBar = false" routerLinkActive="active"
              [routerLink]="['/contact']">Contact</a>
          </li>
          <li class="nav-item">
            <div class="btn-group" dropdown>
              <button dropdownToggle type="button" class="no-bg-btn nav-link" [class.active]="
                  router.isActive('/' + routes.whyBranford, true) ||
                  router.isActive('/' + routes.about, true) ||
                  router.isActive('/' + routes.history, true) ||
                  router.isActive('/' + routes.team, true)
                ">
                About
                <img src="/assets/images/arrow-down.svg" />
              </button>
              <ul *dropdownMenu class="dropdown-menu" role="menu">
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false" [routerLink]="routes.whyBranford"
                    routerLinkActive="active">Why Branford</a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false" [routerLink]="routes.about"
                    routerLinkActive="active">Services</a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false" [routerLink]="routes.team"
                    routerLinkActive="active">Management Team</a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false"
                    [routerLink]="routes.assetRecovery" routerLinkActive="active">
                    Asset Recovery Programs
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" role="button" (click)="showNavBar = false" [routerLink]="routes.blogList"
                    routerLinkActive="active">
                    News
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <!-- <li class="nav-item" *ngIf="!loggedIn || role != 'Buyer'">
            <button type="button" class="btn btn-colored" role="button"
              (click)="openModalFile('register'); showNavBar = false">
              Create Account
            </button>
            <button type="button" class="btn btn-white-border" role="button"
              (click)="openModalFile('login'); showNavBar = false">
              Sign In
            </button>
          </li> -->

          <!-- <li class="nav-item menu-notifications-icon" *ngIf="loggedIn && role == 'Buyer'">
            <div class="noti-dropdown" notification-counter></div>

            <div class="menu-mobile-dd">
              <div class="header-profile-menu">
                <button class="my-account-dropdown" mat-button [matMenuTriggerFor]="headermenu">
                  <span class="hpm-img">
                    <img src="../assets/images/user.svg" />
                  </span>
                  <span *ngIf="firstName !== undefined && lastName !== null">
                    {{ firstName }} {{ lastName }}
                  </span>
                </button>
                <mat-menu #headermenu="matMenu" xPosition="before">
                  <div class="header-profile-menu">
                    <button mat-menu-item routerLink="/profile/my-profile" routerLinkActive="active">
                      My Profile
                    </button>
                    <button mat-menu-item routerLink="/profile/registrations" routerLinkActive="active">
                      My Registrations
                    </button>
                    <button mat-menu-item routerLink="/profile/active-bids" routerLinkActive="active">
                      Active Bids
                    </button>
                    <button mat-menu-item routerLink="/profile/my-watchlist" routerLinkActive="active">
                      My Watchlist
                    </button>
                    <button mat-menu-item routerLink="/profile/bid-history" routerLinkActive="active">
                      Bid History
                    </button>
                    <button mat-menu-item routerLink="/profile/setting" routerLinkActive="active">
                      Notification Settings
                    </button>
                    <button mat-menu-item role="button" (click)="logout()">
                      Logout
                    </button>
                  </div>
                </mat-menu>
              </div>
            </div>
          </li> -->
        </ul>
      </div>

      <div class="nav-bar-shadow" *ngIf="showNavBar" role="button" (click)="showNavBar = false"></div>
    </nav>
  </div>
</header>
